require("../../scss/contacto.scss");
import validate from 'jquery-validation';
import MatchHeight from 'jquery-match-height';

$.extend(jQuery.validator.messages, {
  required: "Este campo es obligatorio.",
  remote: "Por favor, completa este campo.",
  email: "Por favor, escribe una dirección de correo válida",
  url: "Por favor, escribe una URL válida.",
  date: "Por favor, escribe una fecha válida.",
  dateISO: "Por favor, escribe una fecha (ISO) válida.",
  number: "Por favor, escribe un número entero válido.",
  digits: "Por favor, escribe sólo dígitos.",
  creditcard: "Por favor, escribe un número de tarjeta válido.",
  equalTo: "Por favor, escribe el mismo valor de nuevo.",
  accept: "Por favor, escribe un valor con una extensión aceptada.",
  maxlength: jQuery.validator.format("Por favor, no escribas más de {0} caracteres."),
  minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
  rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
  range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
  max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
  min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
});

var contacto = function(){

	var sections, getHash, submitContacto, initForm;

	constructor = function(){
		$('.equalRow .equalCol').matchHeight();
	}

    initForm = function(){
        console.log('initForm')
        $("#formContacto").validate();
        $("#formContacto").submit(function(){
            console.log("form default submit, flalse")
            return false;
        });
        var rc = grecaptcha.render('recaptchaDom', {
            'sitekey' : $("#recaptchaDom").data("sitekey"),
            'callback' : window.submitForm,
            'size' : "invisible",
            'badge' : 'inline'
        });

        $("#formSubmit").click(function(){
            console.log("CLICK FORM SUBMIT");
            if($("#formContacto").valid()){
                grecaptcha.reset(rc);
                $("#formThanks").removeClass("error").html("Enviando...");
                $("#formSubmit").addClass("disabled");
                grecaptcha.execute(rc);
            }else{
                $('.equalRow .equalCol').matchHeight();
            }
            return false;
        })

        //if hash setted, attempt value set
        var hash = APP.getHash();
        if(hash){
            $("#motivo").val(hash);
        }
    }

	resizeWin = function(viewportSize){

	}

    submitContacto = function(){
        console.log("SUBMIT CONTACTO")
        var data = $('#formContacto').serialize();
        $.post(
            $('#formContacto').attr("action"),
            data,
            function(response){
                if(response.success != 1){
                    $("#formThanks").css({display:"block"}).addClass("error").html(response.msg);
                    grecaptcha.execute();
                }else{
                    $("#formThanks").css({display:"block"}).removeClass("error").html("Gracias. Nos contactaremos con vos a la brevedad.");
                }
            }
        ).fail(function() {
            $("#formThanks").css({display:"block"}).addClass("error").html("Se produjo un error. Inténtalo más tarde. <span class='small'>(1)</small>");
            grecaptcha.execute();
        });
    }

	var setupMap = function(){
		
		var mapContainer = document.getElementById('mapa');
		if(mapContainer){
			var latlngdata = $(mapContainer).data("latlng");
			latlngdata = String(latlngdata).split(",");
			var myLatLng = {lat: parseFloat(latlngdata[0]), lng: parseFloat(latlngdata[1])};

	        var map = new google.maps.Map(mapContainer, {
	          zoom: 18,
	          center: myLatLng,
    		  mapTypeControl: false,
    		  fullscreenControl: false,
    		  rotateControl: false,
    		  streetViewControl: false,
    		  tilt: 20,
    		  styles: mapStyle
	        });

            
	        var marker = new google.maps.Marker({
	          position: myLatLng,
	          map: map,
	          icon: window.markerIcon,
	          title: window.markerTitle
	        });
        }
	}

	window.initMap = setupMap;
	$(document).ready(constructor);

    window.submitForm = submitContacto;
    window.iniFormContacto = initForm;

    var mapStyle = [
        {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-15"
                },
                {
                    "lightness": "0"
                },
                {
                    "gamma": "1"
                },
                {
                    "weight": "1"
                },
                {
                    "hue": "#7373A5"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "saturation": "-13"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#7373A5"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#266b46"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "weight": "1.21"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "weight": "0.74"
                },
                {
                    "gamma": "1.00"
                },
                {
                    "lightness": "0"
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#7373A5"
                },
                {
                    "saturation": "-42"
                },
                {
                    "lightness": "-17"
                },
                {
                    "gamma": "2.37"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -70
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "saturation": "-62"
                },
                {
                    "lightness": "-48"
                },
                {
                    "gamma": "0.00"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "saturation": -60
                }
            ]
        }
    ];

	return {
		resize: resizeWin
	}
}

contacto();